import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import UserTransactionHistory from "../../components/SuperAdmin/UserTransactionHistory";

export default withRouter(connect()(UserTransactionHistory));
